module.exports = __webpack_public_path__ + "img/browser_magnifie_icon.2308df1b.png";